import i18n from '@/i18n'

const ShineObj = {
  showTips: false,
  timer: null,
  titleDefault: "YiKeTong",
  hidden: null,
  visibilityChange: null,

  init({ titleDefault = '' }) {
    this.titleDefault = titleDefault
    // 是否有会话权限
    // let chatPermission = Array.from(document.querySelectorAll('.ekt-menu-bar .ekt-menu-bar-item-title')).some(e => e.innerText == '会话')
    // if (!chatPermission) {
    //   // 没有会话权限
    //   return;
    // }
    this.handleBrowser();
    window.shineObj = ShineObj
  },

  // 浏览器兼容处理
  handleBrowser() {
    if (typeof document.hidden !== "undefined") {
      this.hidden = "hidden";
      this.visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") {
      this.hidden = "mozHidden";
      this.visibilityChange = "mozvisibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      this.hidden = "msHidden";
      this.visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      this.hidden = "webkitHidden";
      this.visibilityChange = "webkitvisibilitychange";
    }
  },

  // 来了新消息
  newsCome() {
    if (this.timer) {
      return;
    }
    this.timer = setInterval(() => {
      if (!document[this.hidden] && this.ifChatTabActive()) {
        // 切回本页chatIframe
        this.reset();
        return;
      }
      this.shine();
    }, 500);
  },

  // 判断ekt中chatTab页签是否处于激活状态
  ifChatTabActive() {
    const tabnode = document.querySelector('#tab-chat')

    return tabnode && tabnode.className.includes('is-active');
  },

  // 恢复原来的title 和图标
  reset() {
    document.title = this.titleDefault;
    clearInterval(this.timer);
    this.timer = null;
  },
  // 闪烁
  shine() {
    if (!this.showTips) {
      document.title = `【${i18n.t('common.newChatMessage')}】`;
      
      this.showTips = true;
    } else {
      document.title = this.titleDefault;
      this.showTips = false;
    }
  }
};

export default ShineObj



// WEBPACK FOOTER //
// ./src/assets/js/shineTitle.js